import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import ClanThemeNavPanel from "@/scenes.ui.clan/clan-theme-nav-panel";
import {Keys} from "@/constants/key";
import {Clan} from "@/store/clan/types";
import {Tr} from "@/i18n/i18n";
import {Settings} from "@/constants/settings";
import CU from "@/utils/c-u";

export class ClanThemePanel extends VerticalLongPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, clan: Clan, callback: (themeNumber: number) => unknown) {
        super(scene, canvas, Tr('tpcs'));

        let self = this;

        let chooseTheme = TextUtils.addTextByFamily(scene, Tr('pick.thm'), 0, -190,
            '#ffd465', 17, 'normal', 480, Fonts.MYRIADPRO_REGULAR);

        let priceText = TextUtils.addTextByFamily(scene, Tr('thm.cmnt'), 0, 92,
            '#cecece', 9, 'normal', 360, Fonts.ARIAL_MT);

        this.add([chooseTheme, priceText]);

        scene.load.image(Keys.CLAN_THEME_BORDER, 'assets/clan/border.png');
        let themes: string[] = [];
        for (let i = 0; i <= 9; ++i) {
            scene.load.image(Keys.CLAN_THEME_PREFIX + i, `assets/clan/back_${i}/small.jpg`);
            themes.push(Keys.CLAN_THEME_PREFIX + i);
        }
        scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            let nav = new ClanThemeNavPanel(scene, canvas, 0, -50, themes, () => {});
            self.add(nav);

            let butt = this.addCustomButton(0, 185, Tr('vibrat'), Keys.UI_ART_GREEN_BUTTON,
                undefined, Keys.IC_100_MITHRIL, () => {
                callback(nav.getCurrentStartIndex());
            });

            let speedupPriceText = TextUtils.addText(scene,
                clan.clanThemeChanges < Settings.CLAN_THEME_FREE_CHANGES ? '0' : String(Settings.CLAN_THEME_CHANGE_PRICE),
                0, butt.y / CU.S + 36, '#ffffff', 25, 'bold', 200);
            self.add(speedupPriceText);
        });
        scene.load.start();
    }

    protected onClose(): void {

    }

}
